import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
var api = ''
var ipcRender
if (navigator.userAgent.indexOf('Electron') > -1) {
  try {
    ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer
    ipcRender.send('getLocalVersionInfo')
    ipcRender.on('localVersionInfo', (event, info) => {
      window.$infoName = info.name
      if (info && info.code == 'sanbaoSmart' && compairVersion(info.version, '1.1.13') <= 0) {
        changeArea()
      }
    })
  } catch (e) {
    console.log(e)
  }
}
var ua = navigator.userAgent.toLowerCase()
// if (ua.match(/cmeplaza/i) == "cmeplaza"){
//     changeArea();
// }
function compairVersion(v1, v2) {
  const ZERO_STR = '000000000000000000000000000000000000000000'
  if (v1 === v2) {
    return 0
  }
  let len1 = v1 ? v1.length : 0
  let len2 = v2 ? v2.length : 0
  if (len1 === 0 && len2 === 0) {
    return 0
  }
  if (len1 === 0) {
    return 1
  }
  if (len2 === 0) {
    return -1
  }
  const arr1 = v1.split('.')
  const arr2 = v2.split('.')
  const length = Math.min(arr1.length, arr2.length)
  for (let i = 0; i < length; i++) {
    let a = arr1[i]
    let b = arr2[i]
    if (a.length < b.length) {
      a = ZERO_STR.substr(0, b.length - a.length) + a
    } else if (a.length > b.length) {
      b = ZERO_STR.substr(0, a.length - b.length) + b
    }
    if (a < b) {
      return 1
    } else if (a > b) {
      return -1
    }
  }
  if (arr1.length < arr2.length) {
    return 1
  } else if (arr1.length > arr2.length) {
    return -1
  }
  return 0
}
function changeArea() {
  if (window.location.origin.indexOf('520ezj') > -1) {
    axios.defaults.baseURL = 'http://localhost:3002'
  } else if (window.location.origin.indexOf('cmeplaza') == -1) {
    axios.defaults.baseURL = 'http://localhost:3001'
  }
}

if (window.location.href.indexOf('.com') == -1) {
  if (window.location.hostname.indexOf('10.0.6') > -1) {
    api = '/api'
  }
  window.document.domain = window.location.hostname
} else {
  //解决跨域
  window.document.domain = window.location.host.split('.').length > 2 ? window.location.host.split('.').slice(-2).join('.') : window.location.host
}
var timer
//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      //判断接口请求完毕调用抓取方法打开弹窗
      if (window.newVue.getQuery('grab') == 'yes' && window.$grabYes) {
        startGrab()
      }
    }, 1500)
    if (config.method == 'get') {
      config.data = JSON.stringify(config.data)
      config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

//响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          console.log('错误请求')
          break
        case 401:
          console.log('未授权，请重新登录')
          break
        case 403:
          console.log('拒绝访问')
          break
        case 404:
          console.log('请求错误,未找到该资源')
          break
        case 405:
          console.log('请求方法未允许')
          break
        case 408:
          console.log('请求超时')
          break
        case 500:
          console.log('服务器端出错')
          break
        case 501:
          console.log('网络未实现')
          break
        case 502:
          console.log('网络错误')
          break
        case 503:
          console.log('服务不可用')
          break
        case 504:
          console.log('网络超时')
          break
        case 505:
          console.log('http版本不支持该请求')
          break
        default:
          console.log(`连接错误${err.response.status}`)
      }
    } else {
      console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response)
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params, item) {
  // if(isClient){
  //     isClients(url,params);
  // }else{
  var name = location.origin + '/' + item + '/' + Vue.prototype.getQuery('appId')
  return new Promise((resolve, reject) => {
    if (item && Vue.prototype.getCanExpireLocal(name)) {
      resolve(JSON.parse(Vue.prototype.getCanExpireLocal(name)))
    } else {
      axios
        .get(api + url, {
          params: params
        })
        .then((response) => {
          if (response && response.data && response.data.state == 1) {
            item && Vue.prototype.setCanExpireLocal(name, JSON.stringify(response.data), 600000)
          }
          response && resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    }
  })
  // }
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, item) {
  // if(isClient){
  //     isClients(url,params);
  // }else{
  return new Promise((resolve, reject) => {
    axios.post(api + url, qs.stringify(data)).then(
      (response) => {
        if (response && response.data) {
          resolve(response.data)
        }
      },
      (err) => {
        reject(err)
      }
    )
  })
  // }
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data)
      },
      (err) => {
        reject(err)
      }
    )
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data)
      },
      (err) => {
        reject(err)
      }
    )
  })
}

/**
 * 封装all请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const http = {
  axios,
  get,
  put,
  patch,
  post
}

/**
 * 打开弹窗方法
 * @param params
 * @returns {String}
 */

export function openIframe(src, opt = {}) {
  var { type = 'center', height = 300, width = 300, left = 0, top = 0 } = opt
  var pW, pH

  if (type == 'center') {
    pW = window.outerWidth
    pH = window.outerHeight
    left = (pW - width) / 2
    top = (pH - height) / 2
  }

  if (type == 'left') {
    left = 0
    top = (pH - height) / 2
  }

  if (type == 'right') {
    left = pW - width
    top = (pH - height) / 2
  }

  if (type == 'top') {
    top = 0
    left = (pW - width) / 2
  }

  if (type == 'bottom') {
    top = pH - height
    left = (pW - width) / 2
  }
  this.component('my-iframe', {
    render: function (createElement) {
      return createElement('iframe', {
        class: {
          vframe: true
        },
        style: {
          left: left + 'px',
          top: top + 'px'
        },
        attrs: {
          name: 'myIframe',
          src: src,
          width: width,
          height: height
        }
      })
    },
    data() {
      return {
        render: false
      }
    },
    mounted() {},
    methods: {}
  })
}

/**
 * getProduct
 * @param pData(产品列表)，ind
 * @returns {String}
 */
export function getProduct(pData, ind) {
  var pictures = []
  var others = []
  var btns = []
  if (!pData.contentArr[ind] || !pData.contentArr[ind].standardJson) {
    return false
  } else {
    pData.contentArr[ind].standardJson.forEach((ele) => {
      // if(ele.isShow!='0'){
      if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0)) {
        pictures.push(ele.standardData)
      } else if (ele.standardType == 0) {
        others.push(ele)
      } else if (ele.standardType == 3) {
        btns.push(ele)
      }
      // }
    })
    return {
      pictures: pictures.splice(0, 4),
      others: others.splice(0, 5),
      btns: btns.splice(0, 2)
    }
  }
}

/**
 * handleDetail
 * @param ite(产品信息)
 * @param handleDetail(跳转详情)
 */

export async function handleDetail(_this, ite, flowId, data) {
  const allList = []
  if (Array.isArray(ite.btns)) {
    allList.push(...ite.btns)
  }
  if (Array.isArray(ite.others)) {
    allList.push(...ite.others)
  }
  if (Array.isArray(ite.pictures)) {
    allList.push(...ite.pictures)
  }
  const linkList = allList
    .filter((ite) => ite.standardData && typeof ite.standardData == 'string' && ite.standardData.indexOf('http:') === 0 && ite.standardData.indexOf('/showimg') == -1)
    .map((ite) => {
      if ((typeof ite.standardData == 'string' && ite.standardData.indexOf('.jpg') == -1) || ite.standardData.indexOf('.png') == -1 || ite.standardData.indexOf('.mp4') == -1) {
        return ite.standardData
      }
    })
  if (linkList.length > 0) {
    this.open(linkList, '_self', ite.standAllName)
    return
  }
  var blockId = _this.blockId
  var nodeId = _this.nodeId ? _this.nodeId : window.$nodeId ? window.$nodeId : ite.nodeId ? ite.nodeId : ''
  var sceneId = ite.sceneId
  var sceneGroupId = ite.sceneGroupId
  var contentId = ite.contentId ? ite.contentId : _this.contentId
  var appId = ite.appId ? ite.appId : _this.getQuery('appId')

  // var list = [_this.$store.state.preItem, ..._this.listData];
  // _this.$store.commit('setDetailNav', { blockId: blockId, list: list });
  _this.$store.commit('setNodeId', _this.nodeId)
  _this.$store.commit('setFlowId', _this.blockData)
  if (ite.standardData && ite.standardData.indexOf('http:') === 0) {
    if (ite.standardData.indexOf('.jpg') == -1 || ite.standardData.indexOf('.png') == -1 || ite.standardData.indexOf('.mp4') == -1) {
      this.open(ite.standardData, '_self', ite.standAllName)
      return
    }
  }
  if (ite && ite.standAllTag) {
    var link = ''
    for (var i = 0; i < ite.standAllTag.length; i++) {
      if (ite.standAllTag[i].name == '主域名') {
        link = ite.standAllTag[i].data
        break
      }
    }
    if (link && link.indexOf('cmeplaza') == -1 && link.indexOf('520ezj') == -1) {
      this.open(link, '_self', ite.standAllName)
      return
    }
  }
  var third = false,
    wzUrl = ite && ite.contentWzUrl ? ite.contentWzUrl : ite.contentDsfWzUrl
  let resq = await _this.$http.get('/zciid-deliverable/api/con/check/url.json', { url: wzUrl })
  var array = ['jd.com', 'dianping.com'].filter((tags) => wzUrl && wzUrl.indexOf(tags) > -1)
  if (resq.state == 1 || array.length) {
    third = true
  }
  if (wzUrl) {
    if (ite.contentWzUrl && ite.contentWzUrl.indexOf('uoqid') > -1) {
      //客户环境跳转520emv环境，加入购物车使用客户环境信息
      var prevMerchantId = ite.appId,
        prevMerchantName = ite.appName,
        prevTypes = encodeURIComponent(location.origin),
        prevPfId = window.$pfId ? window.$pfId : '',
        prevAppId = _this.$appId
      wzUrl += '&prevMerchantId=' + prevMerchantId + '&prevMerchantName=' + prevMerchantName + '&prevTypes=' + prevTypes + '&prevPfId=' + prevPfId + '&prevAppId=' + prevAppId

      if (_this.$store.state.userInfo.userId) {
        //跨环境登录
        const parser = document.createElement('a')
        //获取wzUrl的域名
        parser.href = wzUrl

        wzUrl = `${location.origin}/cme-sso-app/cas?servers=${encodeURIComponent(`${parser.origin}/cme-sso-app/app-h5-redirect?toUrl=${encodeURIComponent(wzUrl)}&ref=${encodeURIComponent('http://' + location.hostname)}%2F`)}`
      } else {
        wzUrl += '&localUserId=' + localStorage.getItem('wxud')
      }
    }

    if (_this.$store.state.userInfo.userId && location.hostname == 'kh.520ezn.com' && wzUrl.indexOf('520emv.com') > -1) {
      wzUrl = `https://520emv.com/cme-sso-app/cas?servers=${encodeURIComponent(`${document.location.origin}/uoqid/sso/login?toUrl=${encodeURIComponent(wzUrl)}`)}`
    }
    _this.open(wzUrl, '_blank', ite && ite.others && ite.others[0].standardData ? ite.others[0].standardData : ite && ite.standAllName ? ite.standAllName : '', third ? 'third' : '', '', contentId, ite)
    return
  }
  var obj = { appId: appId, blockId: nodeId, sceneId: sceneId, contentId: contentId, sceneGroupId: sceneGroupId, floorflowId: flowId, dataType: ite.sign ? ite.sign : 1, meetingId: ite.meetingId, communicationId: ite.communicationId }
  if (!ite.meetingId) {
    delete obj.meetingId
  }
  if (!ite.communicationId) {
    delete obj.communicationId
  }
  let text = _this.$router.resolve({ path: 'odzid', query: obj })
  _this.open(text.href, '_blank', ite && ite.others && ite.others[0].standardData ? ite.others[0].standardData : ite && ite.standAllName ? ite.standAllName : '')
  // _this.routerJump('push','odzid',obj,ite.standAllName);
}

/**获取勾选商圈
 * handleCircleChoose
 * @param tabType(获取初始化选中)
 * @param nodeNavLeft(左侧选择流程)
 */

export function handleCircleChoose(fId, clickFlowId = '') {
  return get('/zciid-deliverable/showPlatformStyle/flow/api/getCircleListByFlowId.json', {
    flowId: fId,
    clickFlowId: clickFlowId
  })
}

/**获取商圈上级分组
 * initGroupCircle
 * @param Array 商圈列表
 */

export function initGroupCircle(list = []) {
  var circleGroupList = []
  const hasOrgCircle = list.some((el) => el.types == 'orgCircle')
  const hasManageCircle = list.some((el) => el.types == 'manageCircle')
  const hasTempCircle = list.some((el) => el.types == 'tempCircle')
  if (hasOrgCircle) {
    circleGroupList.push({ name: '组织商圈', flowType: 'circle', types: 'orgCircle' })
  }
  if (hasManageCircle) {
    circleGroupList.push({ name: '管理商圈', flowType: 'circle', types: 'manageCircle' })
  }
  if (hasTempCircle) {
    circleGroupList.push({ name: '临时商圈', flowType: 'circle', types: 'tempCircle' })
  }
  return circleGroupList
}

/**获取商圈下边的人
 * handleCirclePerson
 * @param
 * @param
 */

export function handleCirclePerson(item) {
  //获取商圈人员
  return get('/zciid-deliverable/showPlatformStyle/flow/api/getCircleUserList.json', {
    circleId: item.selectCircleId,
    pfId: item.pfId
  })
}

//获取初始化选中activeTabType
export function getActiveType(floorTabShow = 'down', flowEnName) {
  // if (flowEnName == 'media-scene') {
  return ['up', 'down', 'right', 'center', 'left'].filter((tab) => {
    return floorTabShow.indexOf(tab) > -1
  })
  // }
  // return ['down', 'up', 'right', 'center', 'left' ].filter((tab) => {
  //     return floorTabShow.indexOf(tab) > -1
  // })
}

export const blockGetData = {
  getProduct,
  handleDetail,
  handleCircleChoose,
  initGroupCircle,
  handleCirclePerson,
  getActiveType,
  getpfId
}

export function getpfId() {
  var exports = window.location.host,
    pfId
  switch (exports) {
    case '520ezj.com':
      pfId = '228659633701650432'
      break
    case '520emv.com':
      pfId = 'aassid-com-613446-681157-p'
      break
    case '520ezn.com':
      pfId = 'aassid-com-112922-428730-p'
      break
    default:
      pfId = ''
      break
  }
  return pfId
}

export function os() {
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian
  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isChrome: isChrome
  }
}

export const common = {
  os
}



// WEBPACK FOOTER //
// ./src/export.js